import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { portalBase } from "@/lib/portal";
import { PortalShell, Campo } from "./PortalShell";

export function PortalRecuperar() {
  const [paso, setPaso] = useState("correo");
  const [f, setF] = useState({ email: "", code: "", password: "", password2: "" });
  const [msg, setMsg] = useState("");
  const [cargando, setCargando] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const llamar = async (fn) => {
    setCargando(true);
    try { await fn(); } catch (x) { toast.error(formatApiErrorDetail(x?.response?.data?.detail)); } finally { setCargando(false); }
  };
  const pedir = (e) => { e.preventDefault(); llamar(async () => { const r = await api.post("/portal/auth/forgot", { email: f.email }); setMsg(r.data.mensaje); setPaso("codigo"); }); };
  const cambiar = (e) => {
    e.preventDefault();
    if (f.password !== f.password2) { toast.error("Las contraseñas no coinciden"); return; }
    llamar(async () => { const r = await api.post("/portal/auth/reset", { email: f.email, code: f.code, password: f.password }); setMsg(r.data.mensaje); setPaso("listo"); });
  };
  const subs = { correo: "Te enviamos un código de 6 dígitos a tu correo.", codigo: msg, listo: "" };
  return <PortalShell titulo="Recuperar contraseña" sub={subs[paso]}>
    {paso === "correo" && <form onSubmit={pedir} className="space-y-4" data-testid="portal-recuperar-correo">
      <Campo label="Correo de tu cuenta" type="email" autoComplete="email" value={f.email} onChange={set("email")} required data-testid="portal-rec-email" />
      <button disabled={cargando} className="pa-btn" data-testid="portal-rec-pedir">{cargando ? "Enviando…" : "Enviar código"}</button>
    </form>}
    {paso === "codigo" && <form onSubmit={cambiar} className="space-y-4" data-testid="portal-recuperar-codigo">
      <Campo label="Código de 6 dígitos" inputMode="numeric" pattern="\d{6}" maxLength={6} autoComplete="one-time-code" value={f.code} onChange={set("code")} required data-testid="portal-rec-codigo" />
      <Campo label="Contraseña nueva (mín. 12, con mayúscula, minúscula, número y símbolo)" type="password" minLength={12} autoComplete="new-password" value={f.password} onChange={set("password")} required data-testid="portal-rec-password" />
      <Campo label="Repetir contraseña" type="password" minLength={12} autoComplete="new-password" value={f.password2} onChange={set("password2")} required data-testid="portal-rec-password2" />
      <button disabled={cargando} className="pa-btn" data-testid="portal-rec-cambiar">{cargando ? "Guardando…" : "Cambiar contraseña"}</button>
      <button type="button" onClick={() => setPaso("correo")} className="pa-link text-xs" data-testid="portal-rec-reenviar">Pedir otro código</button>
    </form>}
    {paso === "listo" && <p className="p-3 rounded-xl bg-[#3fae7a]/15 border border-[#3fae7a]/40 text-sm" data-testid="portal-rec-ok">{msg}</p>}
    <p className="text-xs"><Link to={`${portalBase()}/login`} className="pa-link" data-testid="portal-rec-volver">Volver a ingresar</Link></p>
  </PortalShell>;
}
